import React, { Component } from 'react';
import PropTypes from 'prop-types';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import enumCache from '@/shared/services/EnumCacheService';
import DataCacheService from '@/shared/services/DataCacheService';
import AssignedToSelector from '@/shared/components/input/AssignedToSelector';
import Checkbox from '@/shared/components/input/Checkbox';
import { getUserClassName } from '@/shared/components/input/UserSearch';
import messages from '../relationOverviewMessages';

export default class UpdateRelationUserModal extends Component {
  state = {
    profile: null,
    userId: null,
    profiles: [],
    users: [],
    updateTasks: false,
    updateTaskData: {
      assignedType: 0,
      assignedUserId: null,
      assignedProfile: null,
    },
  };
  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  componentDidMount() {
    const { intl } = this.props;
    enumCache.getTranslated('employeeprofile', intl).then(profiles => {
      this.setState({
        profiles,
        users: DataCacheService.getUsers(),
      });
    });
  }

  profileChanged = event => {
    const profile = parseInt(event.target.value) || 0;
    this.setState({
      profile,
    });
  };
  userChanged = event => {
    this.setState({
      userId: event.target.value || null,
    });
  };
  assignedToChanged = assignedTo => {
    this.setState({
      updateTaskData: assignedTo,
    });
  };
  isFormInvalid = () => {
    const { profile } = this.state;
    if (profile === null) return true;

    return false;
  };

  onSave = () => {
    const { profile, userId, updateTasks, updateTaskData } = this.state;
    const { onSave } = this.props;

    let updateTaskModel = null;
    if (updateTasks) {
      if (!userId) {
        // User data from assigned user control when user is set to unassigned
        updateTaskModel = {
          oldProfile: profile,
          assignedType: updateTaskData.assignedType,
          newProfile: updateTaskData.assignedProfile,
          newUserId: updateTaskData.assignedUserId,
        };
      } else {
        // Replace with new user
        updateTaskModel = {
          oldProfile: profile,
          assignedType: 2,
          newProfile: null,
          newUserId: userId,
        };
      }
    }

    const model = {
      profile,
      userId,
      updateTasks: updateTaskModel,
    };

    return onSave(model);
  };

  closeModal = () => {
    const { onClose } = this.props;

    this.setState(state => ({
      ...state,
      selectedValue: null,
    }));

    onClose();
  };

  render() {
    const { show, intl } = this.props;
    const { profile, profiles, users, userId, updateTasks } = this.state;

    if (!show) return null;
    const showAssignedToSelector = profile !== null && !userId && updateTasks;
    const assignedToProfiles = showAssignedToSelector
      ? profiles.filter(x => x.id !== profile)
      : undefined;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.UpdateRelationUser)}
        show={show}
        onClose={this.closeModal}
        disabled={this.isFormInvalid()}
        onSave={() => this.onSave()}
      >
        <div className="form-horizontal">
          <div>
            <div className="form-group">
              <div className="col-md-6">
                <select
                  onChange={this.profileChanged}
                  className="form-control"
                  value={profile || ''}
                >
                  {!profile && (
                    <option value="">{intl.formatMessage(messages.SelectAField)}</option>
                  )}
                  {profiles.map(x => (
                    <option key={x.id} value={x.id}>
                      {x.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <select onChange={this.userChanged} className="form-control" value={userId || ''}>
                  <option value="">{intl.formatMessage(messages.Unassigned)}</option>
                  {users.map(x => (
                    <option key={x.id} value={x.id} className={getUserClassName(x)}>
                      {x.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {profile !== null && (
              <div className="form-group">
                <Checkbox
                  extraClass="col-md-12"
                  id="updateTasks"
                  value={updateTasks}
                  onClick={() => this.setState({ updateTasks: !updateTasks })}
                  text={intl.formatMessage(messages.UpdateUserInPlannedTasks)}
                />
              </div>
            )}
            {showAssignedToSelector && (
              <div className="form-group">
                <label className="col-md-12">
                  {intl.formatMessage(
                    messages.RelationUserIsUnassignedWhichUserDoYouWantToAssignToTasks,
                  )}
                </label>
                <div className="col-md-12">
                  <AssignedToSelector
                    onChange={this.assignedToChanged}
                    profiles={assignedToProfiles}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
